/** Remembered sizes for the resizable panels of the annotation workspace (per browser, like the theme). */

export interface PanelSpec { key: string; def: number; min: number; max: number }

export const PANELS = {
  rail: { key: "mb.panel.rail", def: 56, min: 56, max: 200 },
  side: { key: "mb.panel.side", def: 220, min: 180, max: 560 },
  layers: { key: "mb.panel.layers", def: 160, min: 70, max: 900 },
} satisfies Record<string, PanelSpec>;

export const clampSize = (spec: PanelSpec, v: number): number =>
  Number.isFinite(v) ? Math.round(Math.min(spec.max, Math.max(spec.min, v))) : spec.def;

export function readSize(spec: PanelSpec): number {
  try {
    const raw = localStorage.getItem(spec.key);
    return raw === null ? spec.def : clampSize(spec, Number(raw));
  } catch { return spec.def; }
}

export function writeSize(spec: PanelSpec, v: number): void {
  try { localStorage.setItem(spec.key, String(clampSize(spec, v))); } catch { /* storage unavailable */ }
}
